module.exports = __webpack_public_path__ + "img/snail.487c5398.png";